import { Component, NgZone, OnInit } from '@angular/core';
import {
  ApplicationState,
  getProductDetailsPending,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import {
  getFavAppFlavour,
  getFavoriteApp,
  getOptionByMpcUuid,
  getPotentialLockedOption,
  isEpicPricingPlan,
  isSuspended,
  Option,
  OptionStatus,
  PdaResponseModel,
} from '@dch/products-business-logic';
import { combineLatest } from 'rxjs';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import { OptionLockService } from '../../../../services/option-lock.service';
import { GetOptionGroupsConfig } from '../../../../store/actions/magnolia-config.actions';
import { AnalyticsService, TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-change-fav-app',
  templateUrl: './change-fav-app.component.html',
})
export class ChangeFavAppComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  activeFavApp: Option;
  availableFavApps: any[];
  selectedProduct: PdaResponseModel;
  isPendingProductDetails: boolean;
  favAppFlavour: string;
  pendingOrder: boolean;
  isPendingInCart: boolean;
  suspended: boolean;
  showPendingOrder: boolean;
  selectedFavapp: string;
  pendingFor: string;

  editFavApp: boolean;
  isOrdering: boolean;

  private isSubscribed = false;

  constructor(
    private store: Store<ApplicationState>,
    private alertService: AlertsService,
    private optionLockService: OptionLockService,
    private ngZone: NgZone,
    private analyticsService: AnalyticsService,
    private translationService: TranslationService,
  ) {
    super();
    this.editFavApp = false;
    this.isOrdering = false;
  }

  ngOnInit() {
    this.availableFavApps = [];
    this.store.dispatch(new GetOptionGroupsConfig());
    this.addSubscription(
      combineLatest([
        this.store.select(getSelectedProductDetails),
        this.store.select(getProductDetailsPending),
      ]).subscribe((res: [PdaResponseModel, boolean]) => {
        this.favAppFlavour = null;
        this.isPendingProductDetails = res[1];
        if (
          res[0] &&
          res[0].mobileProductDetails &&
          JSON.stringify(this.selectedProduct) !==
            JSON.stringify(res[0].mobileProductDetails)
        ) {
          this.selectedProduct = res[0];
          this.favAppFlavour = getFavAppFlavour(
            this.selectedProduct.mobileProductDetails.activeSubscription,
          );
          if (this.selectedProduct.mobileProductDetails.options) {
            this.activeFavApp = getFavoriteApp(
              this.selectedProduct.mobileProductDetails,
            );
            if (this.activeFavApp) {
              this.selectedFavapp = this.activeFavApp.optionCodeForDescription;
            }
          }
          this.suspended = isSuspended(
            this.selectedProduct.mobileProductDetails,
          );
          this.availableFavApps =
            this.selectedProduct.mobileProductDetails.options?.filter(
              (option) =>
                option?.optionGroup === 'FAVAPP' &&
                option?.ibStatus === OptionStatus.AVAILABLE,
            );
          if (
            !isEpicPricingPlan(this.selectedProduct.mobileProductDetails) &&
            this.activeFavApp &&
            !this.isSubscribed
          ) {
            this.isSubscribed = true;
            WebshopUtils.publishCartRetrival(
              this.selectedProduct.mobileProductDetails.installationId,
              this.selectedProduct.mobileProductDetails.accessNumber,
              this.selectedProduct.mobileProductDetails.plc,
            );
            WebshopUtils.subscribeToCartEvent((data: any) => {
              this.ngZone.run(() => {
                if (data.status === 'PENDING_ORDER') {
                  this.pendingOrder = true; // TODO waiting for design on vhat to display in case of AIA pending order
                  this.selectedFavapp =
                    this.activeFavApp.optionCodeForDescription;
                  this.getPendingChange();
                } else if (data.status === 'LOADED') {
                  const favappMpcUuids = this.availableFavApps.map(
                    (favapp) => favapp.optionCodeForDescription,
                  );
                  this.pendingOrder = false;
                  if (data.products.length !== 0) {
                    const find = data.products.find(
                      (p: any) => favappMpcUuids.indexOf(p.mpcUuid) !== -1,
                    );
                    this.getPendingChange(find);
                  } else {
                    this.getPendingChange();
                  }
                }
              });
            }, this.addSubscription);
            WebshopUtils.subscribeToConfirmationEvent((data: any) => {
              this.ngZone.run(() => {
                const currentProduct: any = [];
                let currentOption: any = [];
                if (data.productDetails) {
                  data.productDetails.forEach((productDetail: any) => {
                    let find = productDetail.products.find(
                      (product: any) =>
                        product.id ===
                          this.selectedProduct.mobileProductDetails
                            .groupMpcUuid ||
                        product.id ===
                          this.selectedProduct.mobileProductDetails
                            .parentProductMpcUuid,
                    );
                    if (find) {
                      currentProduct.push(find);
                    } else {
                      find = this.findCurrentOptionInEvent(productDetail);
                      if (find) {
                        currentOption.push(find);
                      }
                    }
                  });
                  currentProduct.forEach((cp: any) => {
                    currentOption = this.findCurrentOptionInEvent(cp);
                  });
                  if (
                    currentOption &&
                    this.availableFavApps.find(
                      (option) =>
                        option.optionCodeForDescription === currentOption.id,
                    )
                  ) {
                    if (data.action && data.action === 'add') {
                      this.dispatchAlert(
                        'success',
                        this.translationService.getTranslatedValueFor(
                          'mobile.favapp.success.title',
                        ),
                        this.translationService.getTranslatedValueFor(
                          'mobile.favapp.success.description',
                        ),
                        undefined,
                        {
                          event: 'popup-impression',
                          popup: {
                            zone: 'your-fav-app',
                            name: 'save preference confirmation',
                          },
                        },
                      );
                      this.optionLockService.lockOption(
                        this.selectedFavapp,
                        this.selectedProduct.mobileProductDetails.plc,
                        this.selectedProduct.mobileProductDetails.accessNumber,
                      );
                      this.isOrdering = false;
                      this.analyticsService.reportEvent({
                        event: 'order',
                        eventzone: 'choose a new fav-app',
                        eventdetail: 'order button',
                        product: data.productDetails,
                      });
                    }
                  }
                }
              });
            }, this.addSubscription);
            WebshopUtils.subscribeToErrorEvent((data: any) => {
              this.ngZone.run(() => {
                if (data.products) {
                  if (this.findCurrentOptionInEvent(data)) {
                    if (data.action && data.action === 'add') {
                      this.dispatchAlert(
                        'error',
                        this.translationService.getTranslatedValueFor(
                          'message.error.title',
                        ),
                        this.translationService.getTranslatedValueFor(
                          'message.error.description',
                        ),
                        'backend',
                      );
                      this.selectedFavapp =
                        this.activeFavApp.optionCodeForDescription;
                      this.isOrdering = false;
                    }
                  }
                }
              });
            }, this.addSubscription);
            WebshopUtils.subscribeToCloseEvent((data: any) => {
              this.ngZone.run(() => {
                if (data.products) {
                  if (this.findCurrentOptionInEvent(data)) {
                    this.selectedFavapp =
                      this.activeFavApp.optionCodeForDescription;
                    this.isOrdering = false;
                  }
                }
              });
            }, this.addSubscription);
          }
        }
      }),
    );
  }

  public changeFavapp() {
    this.isOrdering = true;
    if (this.isPendingInCart !== undefined || !this.isPendingInCart) {
      if (this.pendingOrder) {
        this.showPendingOrder = true;
        this.isOrdering = false;
        this.selectedFavapp = this.activeFavApp.optionCodeForDescription;
      } else if (this.suspended) {
        this.dispatchAlert('error', 'error', 'suspended', 'backend');
        this.selectedFavapp = this.activeFavApp.optionCodeForDescription;
        this.isOrdering = false;
      } else {
        WebshopUtils.addProduct(
          false,
          this.selectedFavapp,
          'RPO',
          this.activeFavApp.chargeConfiguration.event,
          this.activeFavApp.chargeConfiguration.code,
          'add',
        );
      }
    }
  }

  toggleEditor() {
    this.editFavApp = !this.editFavApp;
    this.selectedFavapp = this.activeFavApp.optionCodeForDescription;
  }

  get isFavAppChanged() {
    return this.activeFavApp.optionCodeForDescription !== this.selectedFavapp;
  }

  private findCurrentOptionInEvent(data: any) {
    return data.products.find((p: any) => {
      const favappMpcuuids = this.availableFavApps.map((fa) => fa.mpcUuid);
      return (
        favappMpcuuids.indexOf(p.mpcUuid) !== -1 ||
        favappMpcuuids.indexOf(p.id) !== -1
      );
    });
  }

  private getPendingChange(find?) {
    const favappMpcUuids = this.availableFavApps.map(
      (favapp) => favapp.optionCodeForDescription,
    );
    if (find) {
      this.pendingFor = getOptionByMpcUuid(
        this.selectedProduct.mobileProductDetails,
        find.mpcUuid,
      ).name;
      this.isPendingInCart = true;
    } else {
      this.pendingFor = undefined;
      const potentialLockedOption = getPotentialLockedOption(
        this.selectedProduct.mobileProductDetails,
        favappMpcUuids,
      );
      if (potentialLockedOption) {
        this.pendingFor = potentialLockedOption.name;
      }
      this.isPendingInCart = !!this.pendingFor;
    }
  }

  private dispatchAlert(
    type: 'error' | 'info' | 'success' | 'warning',
    title: string,
    description: string,
    errorType?: string,
    customTaggingData?: any,
  ): void {
    const alert: Alert = {
      isClosable: true,
      alertKey: 'changeFavappAlert',
      title,
      description,
      type,
      taggingErrorType: errorType,
      taggingData: customTaggingData,
    };
    this.alertService.dispatchAlert(alert);
  }
}
